import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/account/orders")({
  component: lazyRouteComponent(() => import("./-pages/account.orders")),
  head: () => ({
    meta: [
      { title: DICTS.en["account.orders.meta.title"] },
      { name: "description", content: DICTS.en["account.orders.meta.description"] },
      { property: "og:title", content: DICTS.en["account.orders.meta.title"] },
      { property: "og:description", content: DICTS.en["account.orders.meta.description"] },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
